import { useCallback, useState } from "react";
import { Platform } from "react-native";
import { TURNSTILE_SITE_KEY } from "~/lib/constants";

/** Turnstile guards sign-up, sign-in and password reset on the web only. */
export const TURNSTILE_ACTIVE =
  Platform.OS === "web" && Boolean(TURNSTILE_SITE_KEY);

export function useTurnstile() {
  const [token, setToken] = useState<string | null>(null);
  const [resetKey, setResetKey] = useState(0);

  /** Drops the used token and asks the widget for a new one. */
  const reset = useCallback(() => {
    setToken(null);
    setResetKey((key) => key + 1);
  }, []);

  return {
    active: TURNSTILE_ACTIVE,
    token,
    setToken,
    resetKey,
    reset,
    /** False while the spam check is on screen but not yet passed. */
    passed: !TURNSTILE_ACTIVE || Boolean(token),
    /** Token sent to the API, or undefined when not required. */
    captchaToken: TURNSTILE_ACTIVE ? (token ?? undefined) : undefined,
  };
}
